import { render, staticRenderFns } from "./tableConfig.vue?vue&type=template&id=c991b0e0&scoped=true&"
import script from "./tableConfig.vue?vue&type=script&lang=js&"
export * from "./tableConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c991b0e0",
  null
  
)

export default component.exports